import { render, staticRenderFns } from "./FluidBalance.vue?vue&type=template&id=2dbffe00&scoped=true"
import script from "./FluidBalance.vue?vue&type=script&lang=js"
export * from "./FluidBalance.vue?vue&type=script&lang=js"
import style0 from "./FluidBalance.vue?vue&type=style&index=0&id=2dbffe00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbffe00",
  null
  
)

export default component.exports